/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_SubtitleInputs */

const vi_shop_account_subtitle = /** @type {(inputs: Shop_Account_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản khách bán lẻ trên website và Zalo Mini App. Hiện tại tài khoản web và tài khoản Zalo là 2 bản ghi riêng, chưa gộp.`)
};

/**

* @param {Shop_Account_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_subtitle = /** @type {((inputs?: Shop_Account_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_subtitle(inputs)
});